import {
  Button,
  Cascader,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Pagination,
  Radio,
  Row,
  Select,
  Switch,
  TreeSelect,
} from 'antd'
import { useForm } from 'antd/es/form/Form'
import moment from 'moment'
import React, { useState, useRef } from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getCategories, getShareList } from '../../api/api'
import ContentTable from './components/contentTable/contentTable'
import { PlusOutlined } from '@ant-design/icons'
import './index.css'

const { RangePicker } = DatePicker

const RentManage = () => {
  const [componentSize, setComponentSize] = useState('default')
  const [form] = useForm()
  const contentRef = useRef()
  const [payload, setPayload] = useState({ page: '1', pagesize: '10', type: 2 })
  const [total, setTotal] = useState(0)
  const [dictionary, setDictionary] = useState([]) //字典
  const navigate = useNavigate()
  const jumpToNew = () => {
    navigate('/newContent')
  }

  useEffect(() => {
    getShareList({ params: payload }).then((res) => {
      const info = res.data.data
      if (info.total === 0) {
        message.error('未能找到指定条件内容！')
      }
      contentRef.current.changeData(res.data.data.rows)
      setTotal(res.data.data.total)
    })
  }, [payload])

  useEffect(() => {
    //获取初始字典初始数据
    getCategories({
      params: { type: 2 },
    }).then((res) => {
      setDictionary(res.data.data.Categories)
      // console.log(res.data.data.Categories)
    })
  }, [])
  //级联查找的选择
  // const onChange = (value) => {
  //   console.log(value)
  // }

  const pageChange = (e) => {
    //分页改变时的回调函数
    setPayload({
      ...payload,
      page: e,
    })
  }

  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size)
  }
  const handleSubmit = (values) => {
    console.log(values)
    let payload = {
      page: '1',
      pagesize: '10',
      type: 2,
      title_or_content: values.title_or_content,
      classification: values.classification?.[1] ?? values.classification?.[0],
      is_partially_visible: values.is_partially_visible,
    }
    let start = values?.date[0]
    let end = values?.date[1]

    if (start !== '') {
      payload['period_start'] = moment(start).format('YYYY-MM-DD')
    }
    if (end !== '') {
      payload['period_end'] = moment(end).format('YYYY-MM-DD')
    }
    setPayload(payload)
  }

  //重置选项
  const resetSelectors = () => {
    form.resetFields()
  }

  return (
    <div className="contentManage">
      <Form
        initialValues={{
          size: componentSize,
          date: ['', ''],
        }}
        onValuesChange={onFormLayoutChange}
        onFinish={handleSubmit}
        size={componentSize}
        className="contentSelectors"
        form={form}
      >
        <Row>
          <Col span={8}>
            <Form.Item
              label="内容信息"
              name="title_or_content"
              className="contentContent"
              labelCol={{ span: 6 }}
            >
              <Input placeholder="请输入内容编号/内容标题" />
            </Form.Item>
          </Col>
          <Col span={7}>
            {' '}
            <Form.Item
              label="分类"
              name="classification"
              className="contentType"
              labelCol={{ span: 4 }}
            >
              <Cascader
                options={dictionary}
                fieldNames={{
                  value: 'ID',
                  label: 'Name',
                  children: 'SubCategories',
                }}
                placeholder="请选择"
              ></Cascader>
              {/* <Select placeholder="请选择" style={{ textAlign: 'left' }}>
                {dictionary?
                dictionary.map((item,index) => (
                  <>
                    <Select.Option value={item.ID} >{item.Name}</Select.Option>
                  </>
                ))
                :
                null
              }
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item label="发布时间" name="date" className="contentPostTime">
              <RangePicker />
            </Form.Item>
          </Col>
          <Col span={8}>
            {' '}
            <Form.Item
              label="是否部分可见"
              name="is_partially_visible"
              className="isCanLook"
              labelCol={{ span: 6 }}
            >
              <Select placeholder="请选择" style={{ textAlign: 'left' }}>
                <Select.Option value="1">是</Select.Option>
                <Select.Option value="0">否</Select.Option>
              </Select>
            </Form.Item>
          </Col>

          <Col offset={7}>
            {' '}
            <Form.Item style={{ textAlign: 'right' }}>
              {' '}
              <Button
                onClick={resetSelectors}
                style={{ marginRight: '20px', marginLeft: '60px' }}
              >
                重置
              </Button>
              <Button type="primary" htmlType="submit">
                查询
              </Button>
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Button icon={<PlusOutlined />} type="primary" onClick={jumpToNew}>
              新建{' '}
            </Button>
          </Col>
        </Row>
      </Form>
      <ContentTable ref={contentRef} />
      <Pagination
        showQuickJumper
        style={{ textAlign: 'right' }}
        onChange={pageChange}
        total={total}
        key={total}
        pageSize={10}
        // current={1}
        defaultCurrent={1}
        showTotal={(total, range) =>
          `共${total}条记录, 第${range[0]}-${range[1]}条`
        }
      />
    </div>
  )
}
export default RentManage
